var scrollbarSize;
var scrollTop;

const hasScrollbar = () => document.documentElement.scrollHeight > window.innerHeight;

const getScrollbarSize = () => {
  if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

  var doc = document.documentElement;
  var dummyScroller = document.createElement('div');
  dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
  doc.appendChild(dummyScroller);
  scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
  doc.removeChild(dummyScroller);
  return scrollbarSize;
};

const on = () => {
  if (typeof document === 'undefined') return;
  const hasSB = hasScrollbar();
  const sbSize = getScrollbarSize();
  const doc = document.documentElement;
  scrollTop = window.pageYOffset;
  doc.style.cssText = `
    overflow: hidden;
    position: fixed;
    top: ${-scrollTop}px;
    width: ${(hasSB) ? `calc(100% - ${sbSize}px)` : '100%'};
  `;

  const basket = document.querySelector('.basket');
  if (basket) {
    basket.style.width = (hasSB) ? `calc(100% - ${sbSize}px)` : '100%';
  }
};

const off = () => {
  if (typeof document === 'undefined') return;
  const doc = document.documentElement;

  doc.style.cssText = ``;
  window.scroll(0, scrollTop);

  const basket = document.querySelector('.basket');
  if (basket) {
    basket.style.width = '';
  }
};

export default  { on, off, getScrollbarSize, hasScrollbar };



// WEBPACK FOOTER //
// ./frontend/react/utils/noscroll/index.js